export const GET_UNALLOCATED_ACCOUNTS = `
  mutation ($token: String!, $year: Int!, $month: Int) {
    getUnallocatedAccounts(actualsSearch: {token: $token, year: $year, month: $month}) {
      data {
        accountId
        accountName
        createdDate
        spending
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
